<template>
    <div class="@container relative aspect-[175/105]">
        <svg
            class="absolute inset-0 h-full w-full"
            viewBox="109 383 175 105"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M279.057 410.631V481.161H112.852V410.631C112.852 409.175 113.645 407.991 114.624 407.991H277.287C278.264 407.991 279.059 409.175 279.059 410.631H279.057Z"
                fill="black"
            />
            <path
                d="M279.054 415.521V462.376L276.479 466.391L276.433 475.218L272.141 479.971L271.068 481.161H121.917L120.619 479.971L115.94 475.67L115.729 465.084L112.858 460.402L112.846 460.381V415.851L114.032 415.769V460.361L113.975 460.363L116.978 464.946L117.093 475.134L122.667 479.971H270.263L275.278 474.682L275.23 466.256L277.869 462.397V415.521H279.054Z"
                fill="#011119"
            />
            <path
                d="M275.854 393.224H116.264C112.288 393.224 109.055 396.459 109.055 400.432V411.113L118.855 401.166H272.91L283.061 411.113V400.432C283.061 396.457 279.826 393.224 275.852 393.224H275.854Z"
                fill="#1E1E1E"
            />
            <path
                d="M275.051 398.128H117.855L109.05 407.487V477.697L117.855 487.059H275.051L283.06 478.467V406.717L275.051 398.125V398.128ZM279.057 476.557L272.195 483.734L120.216 483.58L112.852 476.401V415.757L120.216 408.578L272.195 408.425L279.057 415.601V476.56V476.557Z"
                :fill="palette.accent"
            />
            <path
                opacity="0.2"
                d="M234.458 393.223H275.853C275.853 393.223 283.062 393.308 283.062 401.015V405.518L282.688 405.142L282.711 401.028C282.711 401.028 283.321 394.597 275.853 393.611L234.792 393.696L234.458 393.221V393.223Z"
                fill="white"
            />
            <path
                d="M283.058 406.698L275.077 398.13H230.985L230.54 397.483H275.428L283.058 405.575V406.698Z"
                fill="#1D252D"
            />
            <path
                d="M137.474 383L133.349 398.468L150.545 398.338L159.778 404.912L273.202 404.524L256.923 383H137.474Z"
                fill="#1E1E1E"
            />
            <path
                opacity="0.2"
                d="M254.512 383.736L137.764 383.541L135.076 393.793L115.734 393.673C110.107 394.641 109.614 399.791 109.614 399.791L109.561 405.562L109.05 406.041L109.08 399.791C109.644 393.868 115.736 393.226 115.736 393.226H134.753L137.358 383.002H257.09L257.734 383.738L254.512 383.736Z"
                fill="white"
            />
            <path
                d="M147.22 397.161H117.507L109.055 406.041V407.488L117.86 398.129H146.642L153.989 404.17L154.406 403.061L147.22 397.161Z"
                fill="#1D252D"
            />
            <path
                d="M154.4 403.06L153.983 404.169L242.584 404.229L242.015 403.273C242.189 403.099 154.4 403.06 154.4 403.06Z"
                fill="#1D252D"
            />
            <path
                opacity="0.2"
                d="M257.445 383H256.446L271.875 404.912H273.202L257.445 383Z"
                fill="white"
            />
            <path
                d="M109.055 407.992L117.956 398.428H146.567L153.989 404.612V404.169L146.69 398.128H117.807L109.055 407.487V407.992Z"
                :fill="palette.accent"
            />
            <path
                d="M279.054 415.459V456.061L276.477 451.89L276.433 417.022L271.059 411.114L121.938 411.059L115.917 416.575L115.683 453.227L112.846 457.9V415.555L120.08 408.422H272.189L279.054 415.459Z"
                fill="#1E1E1E"
            />
            <path
                d="M279.054 476.779V462.217L276.477 466.39L276.433 475.216L271.059 481.124L121.938 481.177L115.917 475.663L115.683 465.051L112.846 460.378V476.681L120.08 483.816H272.189L279.054 476.779Z"
                :fill="palette.band"
            />
        </svg>
        <span
            class="font-title absolute top-[10%] left-[55.1%] max-w-[68%] -translate-x-1/2 -translate-y-1/2 truncate text-[5.4cqw] leading-none font-bold text-white uppercase"
        >
            {{ name }}
        </span>
        <div class="absolute top-[29.5%] left-[9.14%] w-[36.57%]">
            <KillerAvatarFrame :color="color">
                <KillerSkullIcon v-if="icon === 'skull'" :color="color" class="w-[79%]" />
                <KillerCrossIcon v-else :color="color" class="w-[82%]" />
            </KillerAvatarFrame>
        </div>
        <div class="absolute top-[38.1%] left-[53.1%] h-[42.9%] w-px bg-white" />
        <KillerAvatar
            :avatar="avatar"
            :color="color"
            class="absolute top-[39%] left-[61.1%] w-[25.1%]"
        />
    </div>
</template>

<script>
import { getKillerPalette } from '../killerPalette.js'
import KillerAvatar from './KillerAvatar.vue'
import KillerAvatarFrame from './KillerAvatarFrame.vue'
import KillerCrossIcon from './KillerCrossIcon.vue'
import KillerSkullIcon from './KillerSkullIcon.vue'

export default {
    name: 'KillerPlayerCard',
    components: { KillerAvatar, KillerAvatarFrame, KillerCrossIcon, KillerSkullIcon },
    props: {
        name: {
            type: String,
            required: true,
        },
        avatar: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: 'cross',
            validator: (v) => ['cross', 'skull'].includes(v),
        },
    },
    computed: {
        palette() {
            return getKillerPalette(this.color)
        },
    },
}
</script>
